<div class="select-container">
  <h2 class="ion-no-margin">{{ label }}</h2>
  <div [innerHTML]="description"></div>
  <div class="options-container">
    @for(option of options; track $index) {
      <div 
        class="option" 
        [class.selected]="hasSelected(option)"
        (click)="clickOnOption(option)">
        {{ option.value }}
      </div>
    }
  </div>
</div>